import { Component, OnInit,ViewChild } from '@angular/core';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { profile } from '../models/profile';
import { ImageCompressService} from  'ng2-image-compress';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  userSessionData:any
  userDetails:any
  myurl: string;
  pic:any
  profileObj:profile;
  image = { 'URL': '', 'valid': false };
roleName:any
  @ViewChild("emailNotificationText") form: any;

  constructor(private cs:CucurachaAdminService,private toastr: ToastrManager) { 
    this.profileObj=new profile()
    this.myurl = this.cs.endpoint;

  }
  updateProfile(){
    console.log(this.profileObj)
    this.cs.updateAdminUser(this.profileObj).subscribe((data) => {
      this.toastr.infoToastr(data.message);
      window.location.reload();
    })
  }
  fileChangeEvent(fileInput: any) {
    ImageCompressService.filesToCompressedImageSource(fileInput.target.files).then(observableImages => {
      observableImages.subscribe((image) => {
        this.image.URL = image.compressedImage.imageDataUrl;
          this.profileObj.profilePhoto = image.compressedImage.imageDataUrl;
          this.profileObj.profilePhoto = this.profileObj.profilePhoto.replace("data:image/gif;base64,", "");
          this.profileObj.profilePhoto = this.profileObj.profilePhoto.replace("data:image/jpeg;base64,", "");
          this.profileObj.profilePhoto = this.profileObj.profilePhoto.replace("data:image/jpg;base64,", "");
          this.profileObj.profilePhoto = this.profileObj.profilePhoto.replace("data:image/png;base64,", "");
        this.pic=image.compressedImage.imageDataUrl;
        
        }, (error) => {
        this.toastr.errorToastr("Error while converting");
      });
    });
  }
  ngOnInit(): void {
    this.userSessionData = (JSON.parse(localStorage.getItem('user')))
    console.log(this.userSessionData)
    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.profileObj=data[0]
      console.log( this.profileObj._id)
      this.profileObj._id=data[0]._id

      this.profileObj.role_name=data[0].roledetails[0].role_name
      this.pic=this.myurl+'Misc/Images/profilePhotos/'+this.profileObj._id;

    })
  }

}
